import $ from 'jquery';

export function scrollNotice() {
  const notices = $('.J_notice');
  const parent = notices.parent();
  const pager = $('#J_notice_pager');
  const prev = $('#J_notice_prev');
  const next = $('#J_notice_next');

  let pass = false;
  let page = 0;

  to(page);

  prev.click(() => {
    const prev = page - 1;
    to(prev < 0 ? notices.length - 1 : prev);
  });

  next.click(() => {
    const next = page + 1;
    to(next > notices.length - 1 ? 0 : next);
  });

  function to(ind) {
    pass = false;
    pageTo(ind);

    parent.append(notices.eq(ind));

    setTimeout(() => {
      pass = true;
      anime(ind);
    });
  }

  function anime(ind, offset = parent.width()) {
    if (!pass) return;

    const current = notices.eq(ind);
    const width = current.width();
    let next = offset - 1;

    if (next < -width) {
      next = parent.width();
    }

    const t = window.requestAnimationFrame || window.setTimeout;

    t(() => {
      current.css({
        transform: `translateX(${next}px)`,
      });

      anime(ind, next);
    });
  }

  function pageTo(ind) {
    page = ind;
    notices.remove();
    pager.html(`${ind + 1}/${notices.length}`);
  }
}
